import { useEffect, useState } from 'react';
import styles from './list.module.css';
import { Breadcrumbs, Typography } from '@mui/material';
import axios from 'axios';
import { TableLoader } from '../../components/LoaderC';
import Loader from '../../components/Loader';
import { authData } from "../../components/getAuth";
import Modal from 'react-bootstrap/Modal';
import withAdminAuth from "../../components/withAdminAuth";
import 'react-toastify/dist/ReactToastify.css';
import AssignPopupNew from './AssignPopupNew';
import Step1 from './steps/Step1';
import Step2 from './steps/Step2';
import Step3 from './steps/Step3';

const BookingList = () => {
    const auth = authData();
    const [loading, setLoading] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [filterText, setFilterText] = useState('');
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState({ start_date: '', end_date: '' });
    const [assignModalShow, setAssignModalShow] = useState(true);
    const [selectedRows, setSelectedRows] = useState([]);
    const [perPage, setPerPage] = useState(25);
    const [page, setPage] = useState(0);
    const [debouncedQuery, setDebouncedQuery] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [selectedDriverList, setSelectedDriverList] = useState([]);
    const [currentStep, setCurrentStep] = useState(1);
    const [routes, setRoutes] = useState([]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery('page=' + page + '&perPage=' + perPage + '&search=' + filterText + '&start=' + filterData?.start_date + '&end=' + filterData?.end_date);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [page, perPage, filterText, filterData]);

    useEffect(() => {
        if (debouncedQuery) {
            setLoading(true);
            axios(process.env.REACT_APP_API_URL + 'v1/assign-bookings?' + debouncedQuery, {
                headers: {
                    Authorization: `Bearer ${auth?.api_token}`,
                }
            }).then(response => {
                if (response.data.status === 'SUCCESS') {
                    setData(response.data.data);
                    setTotalCount(response.data.total);
                    setContentLoading(false);
                    setLoading(false);
                } else {
                    setContentLoading(false);
                    setLoading(false);
                }
            }).catch(error => {
                setContentLoading(false);
                setLoading(false);
            });
        }
    }, [debouncedQuery, auth?.api_token]);

    const getOptimizeRoute = async () => {
        setLoading(true);

        await axios.post(process.env.REACT_APP_API_URL + 'v1/optimize-route', { drivers: selectedDriverList, pickups: selectedRows }, {
            headers: {
                Authorization: `Bearer ${auth?.api_token}`,
            }
        }).then(response => {
            setLoading(false);
            setRoutes(response.data.data);
            setCurrentStep(2);
        }).catch(error => {
            setLoading(false);
        });
    }

    return (<>
        {loading && <Loader />}
        {contentLoading && <div className="LoaderCard"><div className="Loader TableLoader"><TableLoader /></div></div>}
        {!contentLoading && <div className={`${styles.MainDiv}`}>
            <div className={`${styles.PageTitleWrap}`}>
                <p className={`${styles.PageTitle}`}>Assigned To Driver</p>
                <Breadcrumbs aria-label="breadcrumb" className='breadcrumb'>
                    <Typography color="text.primary">Bookings</Typography>
                    <Typography color="text.primary">Assign Driver</Typography>
                </Breadcrumbs>
            </div>

            <div className={`${styles.MainCard}`}>

                {currentStep === 1 && <Step1 contentLoading={contentLoading} data={data} filterData={filterData} filterText={filterText} totalCount={totalCount} selectedDriverList={selectedDriverList} selectedRows={selectedRows} page={page} perPage={perPage} setPerPage={setPerPage.bind(this)} setPage={setPage.bind(this)} setAssignModalShow={setAssignModalShow.bind(this)} getOptimizeRoute={getOptimizeRoute.bind(this)} setFilterData={setFilterData.bind(this)} setFilterText={setFilterText.bind(this)} setSelectedDriverList={setSelectedDriverList.bind(this)} setSelectedRows={setSelectedRows.bind(this)} />}

                {currentStep === 2 && <Step2 selectedDriverList={selectedDriverList} routes={routes} setCurrentStep={setCurrentStep.bind(this)} />}

                {currentStep === 3 && <Step3 selectedDriverList={selectedDriverList} selectedRows={selectedRows} routes={routes} setCurrentStep={setCurrentStep.bind(this)} setSelectedDriverList={setSelectedDriverList.bind(this)} />}

            </div>
        </div>}

        <Modal show={assignModalShow} onHide={(e) => setAssignModalShow(false)} centered className='CusModal'>
            <Modal.Header closeButton>
                <Modal.Title>Select Driver To Assign</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AssignPopupNew selectedDriverList={selectedDriverList} setSelectedDriverList={setSelectedDriverList.bind(this)} setAssignModalShow={setAssignModalShow.bind(this)} />
            </Modal.Body>
        </Modal>

    </>);

}

export default withAdminAuth(BookingList);